<script setup lang="ts">
import { useAppVersions } from '~/composables/version/useAppVersions'

defineProps<{
  showSeasonalFooterLink: boolean
  seasonalFooterShortLabel: string
  showOnboardingRestartButton: boolean
  supportContactMailtoHref: string
}>()

const emit = defineEmits<{
  openSeasonalWelcome: []
  openTrainingCenter: []
}>()

const { footerLabel, loadAllVersions } = useAppVersions()

onMounted(() => {
  void loadAllVersions()
})

function onOpenSeasonalWelcome(): void {
  emit('openSeasonalWelcome')
}

function onOpenTrainingCenter(): void {
  emit('openTrainingCenter')
}
</script>

<template>
  <footer data-monorg-app-footer>
    <div class="footer-seasonal-slot">
      <button
        v-if="showSeasonalFooterLink"
        type="button"
        class="footer-seasonal-btn"
        :aria-label="`Options animation ${seasonalFooterShortLabel}`"
        @click.stop="onOpenSeasonalWelcome"
      >
        <span class="material-symbols-outlined footer-seasonal-btn__icon" aria-hidden="true">celebration</span>
      </button>
    </div>
    <div class="footer-center">
      <div class="footer-links">
        <a :href="supportContactMailtoHref" target="_blank" rel="noopener noreferrer">
          Contacter le support
        </a>
        <NuxtLink to="/changelog">
          Journal des versions
        </NuxtLink>
        <NuxtLink to="/accessibilite">
          Accessibilité
        </NuxtLink>
        <NuxtLink to="/mentions-legals">
          Mentions légales
        </NuxtLink>
      </div>
      <p class="footer-versions">
        <NuxtLink
          v-if="footerLabel"
          to="/changelog"
          class="footer-versions__link"
          :title="footerLabel"
        >
          {{ footerLabel }}
        </NuxtLink>
        <span v-else class="footer-versions__placeholder" aria-hidden="true">&nbsp;</span>
      </p>
    </div>
    <div class="footer-seasonal-spacer">
      <button
        v-if="showOnboardingRestartButton"
        type="button"
        class="footer-seasonal-btn"
        aria-label="Ouvrir mes formations"
        @click.stop="onOpenTrainingCenter"
      >
        <span class="material-symbols-outlined footer-seasonal-btn__icon" aria-hidden="true">school</span>
      </button>
    </div>
  </footer>
</template>
